module.exports = __webpack_public_path__ + "img/Sam-Kirk-The-Good-Logo.248d38b0.jpg";